export const serverDateTimeFormatter = (dateTime: Date, onlyDate?: boolean) => onlyDate ? dateTime.toISOString().split('T')[0] : dateTime.toISOString().split('.')[0]+'Z';
